module.exports = __webpack_public_path__ + "img/respaldos_adicionales.d53f42da.png";